const Unauthorized = () => {
    return (
        <div className='card flex w-full flex-col'>
            <div className='justify-center'>
                <div className='mx-auto text-center md:col-7 lg:col-6'>
                    <h2 className='display-2 text-bolder text-brand-primary mt-5'>Unauthorized</h2>
                    <h3 className='fadeIn3 fadeInBottom text-brand-primary mt-3'>You are not authorized to view this page.</h3>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
